type NavigatorWithConnection = Navigator & {
  connection?: {
    saveData?: boolean
  }
}

export function canUseWebGL() {
  try {
    const canvas = document.createElement('canvas')
    return Boolean(
      window.WebGL2RenderingContext && canvas.getContext('webgl2'),
    )
  } catch {
    return false
  }
}

export function prefersDataSaving() {
  return Boolean((navigator as NavigatorWithConnection).connection?.saveData)
}

export function scheduleIdleWork(callback: () => void, timeout = 700) {
  const requestIdle = window.requestIdleCallback as
    | typeof window.requestIdleCallback
    | undefined

  if (typeof requestIdle === 'function') {
    const idleId = requestIdle(callback, { timeout })
    return () => window.cancelIdleCallback(idleId)
  }

  const timeoutId = setTimeout(callback, 1)
  return () => clearTimeout(timeoutId)
}
